import EditIcon from "assets/icons/EditIcon";
import PlusIcon from "assets/icons/PlusIcon";
import useKeyboardShortcuts from "helpers/useKeyboardShortcuts";
import {
  JSXElementConstructor,
  ReactElement,
  ReactFragment,
  ReactPortal,
  useCallback,
  useEffect,
  useState,
} from "react";
import Modal from "@mui/material/Modal";
import CloseIcon from "assets/icons/CloseIcon";
import BasicSelect from "components/BasicInputs/BasicSelect";
import reportItems from "assets/js/reportItems";
import { formShortcuts, navigationShortcuts, tableShortcuts } from "constants/keyboardConstant";
import DeleteIcon from "assets/svg/factorHistoryIcon/Delete";

function addSpace(str: string | null) {
  if (str) {
    return str.split("+").join(" + ");
  }
}

function RenderIcon(props: any) {
  const temp = props.item.split("+").join(" + ").split(" ");
  return temp.map((i: any, index: any) => (
    <div
      key={index}
      className={`${
        i === "+"
          ? "text-[#93BDF5] text-2xl"
          : "bg-[#D6E4FF] border rounded-md border-[#93BDF5] text-[#317CE0] min-w-[48px] px-2 h-12 items-center justify-center flex text-xs"
      }`}
    >
      {i}
    </div>
  ));
}

const keyLabel: any = {
  1: "اول",
  2: "دوم",
  3: "سوم",
};

const checkRepetition = (list: any, value: any) => {
  let myList: string[] = [];
  list.map((item: { value: string }) => {
    const temp = item?.value?.split("+")[1];
    temp && myList.push(temp);
  });
  const searchKey = myList.findIndex((item) => item == value);
  if (searchKey < 0) {
    return true;
  }
  return false;
};

const ShortcutSettings = (props: any) => {
  const { settingData, setSettingData } = props;
  const savePersonalShortcut = settingData?.keyboardShortcut ? JSON.parse(settingData.keyboardShortcut) : [];

  const onChange = (key: any, value: any) => {
    let temp = {
      ...settingData,
      [key]: value,
    };
    setSettingData(temp);
  };

  const [personalShortcut, setPersonalShortcut] = useState<any>(savePersonalShortcut);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setMessage({
      type: "message",
      value: "کلید دوم باید بین ۰ تا ۹ باشد",
    });
    setModalDetails(null);
    setSecondKey(null);
  };

  const [modalDetail, setModalDetails] = useState<any>(null);
  const [firstKey, setFirstKey] = useState<string | null>("Alt");
  const [secondKey, setSecondKey] = useState<string | null>(null);
  const [placeHolder, setPlaceholder] = useState<string | null>(null);
  const [selectedKey, setSelectKey] = useState<number>(2);
  const [message, setMessage] = useState<any>({
    type: "message",
    value: "کلید دوم باید بین ۰ تا ۹ باشد",
  });
  // const [selectOption, setSelectOption] = useState<any>(null);
  // handle what happens on key press
  // const handleKey = (val: string) => {
  //   // Perform save action
  // };
  //   useKeyboardShortcuts(["ctrl+s", "s", "ctrl+p", "ctrl+l"], handleKey);

  // handle what happens on key press
  const handleKeyPress = useCallback((event: { key: any }) => {
    let isNum = /^\d+$/.test(event.key);
    if (!isNum) {
      setMessage({
        type: "error",
        value: "لطفا از اعداد برای کلید میانبر استفاده کنید",
      });
    } else {
      setSecondKey(event?.key);
    }
  }, []);

  useEffect(() => {
    // attach the event listener
    document.addEventListener("keydown", handleKeyPress);

    // remove the event listener
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [handleKeyPress]);

  useEffect(() => {
    if (secondKey) {
      if (checkRepetition(personalShortcut, secondKey)) {
        setMessage(null);
      } else {
        setMessage({
          type: "error",
          value: "لطفا از اعداد تکرار برای کلید میانبر استفاده نکنید",
        });
        // setSecondKey(null);
      }
    }
  }, [secondKey]);

  //===== handle what happens on key press

  const updatePersonalKey = () => {
    const findValue = personalShortcut.findIndex((item: { key: any }) => item?.key === modalDetail?.key);

    if (findValue >= 0) {
      var personalKeyTamp = [...personalShortcut];
      personalKeyTamp[findValue] = {
        key: modalDetail.value,
        value: "Alt+" + secondKey,
        label: modalDetail.label,
        route: modalDetail.route,
      };
      setPersonalShortcut(personalKeyTamp);
      onChange("keyboardShortcut", JSON.stringify(personalKeyTamp));
    } else {
      let newPersonal = [...personalShortcut];
      newPersonal.push({
        key: modalDetail.value,
        value: "Alt+" + secondKey,
        label: modalDetail.label,
        route: modalDetail.route,
      });
      setPersonalShortcut(newPersonal);
      onChange("keyboardShortcut", JSON.stringify(newPersonal));
    }

    handleClose();
  };

  const deleteShortcut = (key: string) => {
    let personalTemp = [...personalShortcut];
    const findValue = personalShortcut.findIndex((item: { key: any }) => item?.key === key);
    personalTemp.splice(findValue, 1);
    setPersonalShortcut(personalTemp);
    onChange("keyboardShortcut", JSON.stringify(personalTemp));
  };

  const createOptions = () => {
    let options: { id: number; label: string; value: string; route: string }[] = [];
    reportItems.map((item) => {
      item.subItems.map((i, index) => {
        options = [...options, { id: index, label: i.title, value: i.key, route: i.url }];
      });
    });
    return options;
  };

  return (
    <div className="flex container flex-col ">
      <div className="flex flex-row items-center w-full mb-10 justify-between">
        <span className="text-[#7E8C9E]">میانبر های شخصی</span>
        <div onClick={handleOpen} className="flex flex-row items-center">
          <span className="text-blue-1 font-IRANSansMedium font-medium text-sm ml-3">افزودن میانبر</span>
          <button
            onClick={() => {
              handleOpen();
            }}
            className="bg-[#EBEFF5] w-16 h-12 items-center flex justify-center rounded"
          >
            <PlusIcon scale={0.6} />
          </button>
        </div>
      </div>
      {personalShortcut.map(
        (
          item: {
            label:
              | string
              | number
              | boolean
              | ReactElement<any, string | JSXElementConstructor<any>>
              | ReactFragment
              | ReactPortal
              | null
              | undefined;
            value: string | null;
            key: string;
          },
          index: any
        ) => {
          return (
            <div key={index} className="flex flex-row w-full items-center justify-between mb-12">
              <span className="font-IRANSansMedium font-medium text-base text-dark-6">{item.label}</span>
              <div className="flex flex-row-reverse items-start">
                <button
                  onClick={() => {
                    deleteShortcut(item.key);
                  }}
                  className="bg-[#EBEFF5] w-16 h-12 items-center flex justify-center rounded mr-6"
                >
                  <DeleteIcon scale={0.8} />
                </button>
                <button
                  onClick={() => {
                    setModalDetails(item);
                    setSecondKey(item.value != null ? item.value.split("+")[1] : "");

                    handleOpen();
                  }}
                  className="bg-[#EBEFF5] w-16 h-12 items-center flex justify-center rounded mr-6"
                >
                  <EditIcon />
                </button>

                <div className="flex flex-col items-center ">
                  <div className="flex flex-row-reverse items-center gap-2">
                    <RenderIcon item={item?.value} />
                  </div>
                  {/* <span dir="ltr" className="text-[#3E485B] text-sm italic mt-3 ">
                    {"( "}
                    {addSpace(item?.value)}
                    {" )"}
                  </span> */}
                </div>
              </div>
              {/* )} */}
            </div>
          );
        }
      )}

      <div className="flex flex-col w-full mb-10">
        <span className="text-[#7E8C9E]">میانبر های عمومی</span>
      </div>
      {navigationShortcuts.map((item, index) => {
        return (
          <div key={index} className="flex flex-row w-full items-center justify-between mb-9">
            <span className="font-IRANSansMedium font-medium text-base text-dark-6">{item.label}</span>
            <div className="flex flex-col items-center ">
              <div className="flex flex-row-reverse items-center gap-2">
                <RenderIcon item={item.value} />
              </div>
              {/* <span className="text-[#3E485B] text-sm italic mt-3">
                {"( "}
                {addSpace(item.value)}
                {" )"}
              </span> */}
            </div>
          </div>
        );
      })}
      <div className="flex flex-col w-full mb-10">
        <span className="text-[#7E8C9E]">میانبر های فرم</span>
      </div>
      {formShortcuts.map((item, index) => {
        return (
          <div key={index} className="flex flex-row w-full items-center justify-between mb-9">
            <span className="font-IRANSansMedium font-medium text-base text-dark-6">{item.label}</span>
            <div className="flex flex-col items-center ">
              <div className="flex flex-row-reverse items-center gap-2">
                <RenderIcon item={item?.valueShow ? item?.valueShow : item.value} />
              </div>
              {/* <span dir="ltr" className="text-[#3E485B] text-sm italic mt-3">
                {"( "}
                {addSpace(item.value)}
                {" )"}
              </span> */}
            </div>
          </div>
        );
      })}
      <div className="flex flex-col w-full mb-10">
        <span className="text-[#7E8C9E]">میانبر های جدول</span>
      </div>
      {tableShortcuts.map((item, index) => {
        return (
          <div key={index} className="flex flex-row w-full items-center justify-between mb-9">
            <span className="font-IRANSansMedium font-medium text-base text-dark-6">{item.label}</span>
            <div className="flex flex-col items-center ">
              <div className="flex flex-row-reverse items-center gap-2">
                <RenderIcon item={item?.valueShow ? item?.valueShow : item.value} />
              </div>
              {/* <span dir="ltr" className="text-[#3E485B] text-sm italic mt-3">
                {"( "}
                {addSpace(item.value)}
                {" )"}
              </span> */}
            </div>
          </div>
        );
      })}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[425px]  bg-white rounded-md ">
          <div className="flex flex-row w-full items-center justify-between py-4 px-6 border-b-2 border-[#EBEFF5]">
            <button onClick={handleClose} className="bg-[#EBEFF5] rounded-sm">
              <CloseIcon scale={0.5} />
            </button>
            <span>تعیین میانبر</span>
          </div>
          <div className="flex flex-col justify-around flex-1 h-full mt-10 ">
            <div className="flex flex-col items-center ">
              <BasicSelect
                style={{ width: "80%", direction: "rtl" }}
                options={createOptions()}
                withSearch
                onChange={(_, options) => {
                  setModalDetails(options);
                }}
                placeholder={modalDetail?.label ?? "انتخاب عملیات میانبر"}
              />
            </div>
            <div className="flex w-full flex-row items-center justify-center mt-28 mb-16">
              <div className="relative px-3">
                <div
                  // onClick={() => setSelectKey(1)}
                  className={`flex w-[70px] h-[70px] border bg-white rounded-md items-center justify-center ${
                    selectedKey === 1 ? "border-blue-1" : "border-[#CAD1DE]"
                  }`}
                >
                  <div className="flex w-[50px] h-[50px] rounded-md bg-[#D6E4FF] items-center justify-center">
                    <span>Alt</span>
                  </div>
                </div>
              </div>
              <span className="text-[#93BDF5] text-2xl">+</span>
              <div className="relative px-3">
                <button
                  onClick={() => setSelectKey(2)}
                  className={`flex w-[70px] h-[70px] border bg-white rounded-md items-center justify-center ${
                    selectedKey === 2 || secondKey !== null ? "border-blue-1" : "border-[#CAD1DE]"
                  }`}
                >
                  {secondKey !== null ? (
                    <div className="flex w-[50px] h-[50px] rounded-md bg-[#D6E4FF] items-center justify-center">
                      <span>{secondKey}</span>
                    </div>
                  ) : selectedKey === 2 ? (
                    <div className="flex w-[50px] h-[50px] rounded-md bg-[#D6E4FF] items-center justify-center">
                      <Question />
                    </div>
                  ) : (
                    <div className="flex w-[50px] h-[50px] rounded-md bg-[#F8FAFC] border border-[] items-center justify-center"></div>
                  )}
                </button>
              </div>
              {/* <span className="text-[#93BDF5] text-2xl">+</span>
              <div className="relative px-3">
                <button
                  onClick={() => setSelectKey(3)}
                  className={`flex w-[70px] h-[70px] border bg-white rounded-md items-center justify-center ${
                    selectedKey === 3 || thirdKey !== null ? "border-blue-1" : "border-[#CAD1DE]"
                  }`}
                >
                  {thirdKey !== null ? null : selectedKey === 3 ? (
                    <div className="flex w-[50px] h-[50px] rounded-md bg-[#D6E4FF] items-center justify-center">
                      <Question />
                    </div>
                  ) : (
                    <div className="flex w-[50px] h-[50px] rounded-md bg-[#F8FAFC] border border-[] items-center justify-center"></div>
                  )}
                </button>
              </div> */}
            </div>
            <div className="flex flex-col items-center mb-8 ">
              {(modalDetail === null || secondKey === null) && (
                <span className="text-sm">
                  {modalDetail === null && "عملیات و "} کلید {keyLabel[selectedKey]} میانبر را انتخاب کنید{" "}
                </span>
              )}
              {message !== null ? (
                <span
                  className={`text-xs mt-3 ${message?.type === "error" ? "text-red-500" : " text-[#7E8C9E]"}`}
                >
                  {message.value}
                </span>
              ) : null}
            </div>
            <div className="flex flex-row w-full min-h-[72px] items-center justify-start  px-6 border-t-2 border-[#EBEFF5]">
              <button
                onClick={() => {
                  if (secondKey !== null && modalDetail !== null && message === null) {
                    updatePersonalKey();
                  }
                }}
                className={`${
                  secondKey === null || modalDetail === null || message !== null
                    ? "bg-[#B3BAC3] text-white border border-[#B3BAC3] h-10 min-w-[184px]  items-center justify-center rounded-md "
                    : "bg-blue-1 h-10 min-w-[184px] text-white items-center justify-center rounded-md border border-blue-1"
                }`}
              >
                ذخیره میانبر
              </button>
              <button
                onClick={handleClose}
                className="h-10 bg-white min-w-[120px] text-[#7D96B8] border border-[#7D96B8] items-center justify-center rounded-md ml-4"
              >
                لغو
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ShortcutSettings;

const Question = () => (
  <svg width="19" height="30" viewBox="0 0 19 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.188 8.645c-.71 0-1.285-.592-1.175-1.292C.7 3.1 3.94 0 9.563 0c5.625 0 9.417 3.4 9.417 8.037 0 3.36-1.662 5.72-4.475 7.433-2.75 1.647-3.535 2.795-3.535 5.025v.075a1.25 1.25 0 0 1-1.25 1.25H7.795a1.25 1.25 0 0 1-1.25-1.238l-.007-.5c-.108-3.052 1.192-5.002 4.112-6.78 2.575-1.58 3.493-2.837 3.493-5.07 0-2.447-1.895-4.244-4.815-4.244-2.523 0-4.275 1.322-4.845 3.504-.165.635-.695 1.153-1.35 1.153H1.188ZM8.74 30c1.555 0 2.738-1.185 2.738-2.725 0-1.545-1.183-2.73-2.738-2.73a2.69 2.69 0 0 0-2.717 2.727A2.69 2.69 0 0 0 8.74 30Z"
      fill="#A1B9DA"
    />
  </svg>
);
